/** Dhivehi labels for Single Source Procurement database fields */
export const SINGLE_SOURCE_FIELD_LABELS = {
    pdfDocumentTitle: 'ބީލަމެއް "ސިންގަލް ސޯސް" ޕްރޮކިއުމަންޓް ގެ އުޞޫލުން ވަކިފަރާތަކާ ހަވާލުކޮށްގެން ކުރިއަށް ގެންދިއުމަށް ނިންމުން',
    title: "މަޝްރޫޢުގެ ނަން",
    date: "ތާރީޚް",
    projectLocation: "މަޝްރޫއު ހިންގާ އޮފީސް",
    totalBudget: "ޖުމްލަ ބަޖެޓް",
    amountAllocatedFromCurrentYearBudget: "ހިގަމުންދާ އަހަރަށް ބަޖެޓް ކަނޑައެޅިފައިވާ ވަރު",
    totalExpenditureTillDate: "މިއަދާއި ހަމައަށް ޚަރަދު ކުރެވިފައިވާ ވަރު",
    remainingBudget: "ބަޖެޓްގެ ބާކީ",
    vendorName: "މަސައްކަތް ހަވާލުކުރަން ހުށަހަޅާ ފަރާތް",
    proposedCost: "މަސައްކަތް ނިންމަން ހުށަހަޅާ އަގު",
    proposedDuration: "މަސައްކަތް ނިންމަން ހުށަހަޅާ މުއްދަތު",
    detailsOfConditions: "ސިންގަލް ސޯސް ޕްރޮކިޔުމަންޓް'ގެ އުޞޫލުން ތަކެތި ނުތަވަ ޚިދްމަތް ނުވަތަ މަސައްކަތް ކުރުވަން މެދުވެރިވި ހާލަތް (ދައުލަތުގެ މާލިއްޔަތުގެ ގަވާއިދުގެ 10.20 (ރ) ގައި ބަޔާންކުރާ ހާލަތްތަކުގެ ތެރެއިން މިކަން ކުރުމަށް މެދުވެރިވި ހާލަތް)",
    decisionToSingleSource: "ނިންމި ގޮތް",
    /** PDF section banner for decision, reason, and details (regulation 10.20) */
    decisionToSingleSourceSectionTitle: "ދައުލަތުގެ މާލިއްޔަތު ގަވާއިދުގެ 10.20 ގެ ދަށުން ތަކެތި ނުވަތަ ޚިދްމަތް ނުވަތަ މަސައްކަތެއް ކުރިއަށް ގެންދިއުމަށް ނިންމި ގޮތާއި، އެކަމުގެ ސަބަބާއި އަދި އެކަމުގެ ތަފްސީލު:",
    justification: "ސަބަބު",
    detailsOfJustification: "ތަފްޞީލު",
    submittedBy: "ހުޅަހެޅި ފަރާތް",
    approvedBy: "ހުއްދަދެއްވި ފަރާތް",
    approvalSectionTitle: "އިޤްރާރު: މި ފޯމުގައިވާ މައުލޫމާތުތަކަކީ ދައުލަތުގެ މާލިއްޔަތުގެ ގަވާއިދާއި އެގަވާއިދުގެ ދަށުން ހަދާފައިވާ އުޞޫލުތަކާއި އެއްގޮތްވާ ގޮތުގެ މަތިން ދީފައިވާ ތެދު އަދި ސައްހަ މައުލޫމާތެވެ.",
    approvalName: "ނަން",
    approvalDesignation: "މަޤާމު",
    approvalDate: "ތާރީޚް",
    approvalSignature: "ސޮއި",
};
//# sourceMappingURL=singleSourceFieldLabels.js.map